"use client";

import Image, { type ImageProps } from "next/image";

import { cn } from "@/lib/utils";

/** Public URL for `public/logos/logoBugCircleS.svg`. */
export const SUKHA_BUG_LOGO_CIRCLE_S_PATH = "/logos/logoBugCircleS.svg" as const;

/** Root `<svg width>` / `<svg height>` from `public/logos/logoBugCircleS.svg` (non-square). */
const INTRINSIC_WIDTH = 1280;
const INTRINSIC_HEIGHT = 1024;

export type SukhaBugLogoImageProps = Omit<ImageProps, "src" | "width" | "height">;

/**
 * Circular Sukha bug mark from {@link SUKHA_BUG_LOGO_CIRCLE_S_PATH}. Passes true intrinsic
 * dimensions to `next/image` so layout matches the SVG aspect ratio and dev warnings about
 * asymmetric width/height do not fire.
 *
 * Set display size with CSS (`className="h-8 w-auto"`, `max-h-full`, etc.).
 */
export function SukhaBugLogoImage({
  className,
  alt = "Sukha",
  ...props
}: SukhaBugLogoImageProps) {
  return (
    <Image
      alt={alt}
      className={cn("w-auto", className)}
      height={INTRINSIC_HEIGHT}
      src={SUKHA_BUG_LOGO_CIRCLE_S_PATH}
      width={INTRINSIC_WIDTH}
      {...props}
    />
  );
}
